import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Base64 as base64 } from "js-base64";
import Moment from "react-moment";
import { decode as base64_decode, encode as base64_encode } from "base-64";

const Utils = {
  get: async (url) => {
    let token = "";
    const ldata = await localStorage.getItem("logedInUser");
    if (ldata) {
      token = await JSON.parse(ldata).token;
    }
    let getData = {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
    };

    let res = await fetch(url, getData);

    if (res.status === 401) {
      await Utils.RefreshToken();
      res = await fetch(url, getData);
    }

    const response = await res.json();
    return { status: res.status, data: response ?? [] };
  },

  post: async (url, data = {}) => {
    let token = "";
    const ldata = await localStorage.getItem("logedInUser");
    const json = JSON.parse(ldata);
    if (ldata) {
      token = json.token;
    }
    let postData = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify(data),
    };

    let res = await fetch(url, postData);

    const isRefresh = url.includes("/refresh_token");

    const isLogin = url.includes("/validate_user");

    if (isRefresh && res.status !== 200) {
      localStorage.removeItem("logedInUser");
      return window.location.reload();
    }

    if (res.status === 401 && !isLogin) {
      await Utils.RefreshToken();
      res = await fetch(url, postData);
    }

    const response = await res.json();
    return { status: res.status, data: response };
  },

  getToken: () => {},

  Alert: ({ title = "", text = "", callback, closeOnConfirm = false }) => {
    confirmAlert({
      overlayClassName: "alert",
      customUI: ({ onClose }) => {
        return (
          <div className='customAlert'>
            <h1>{title}</h1>
            <p>{text}</p>
            <div className='buttons'>
              <button className='primary' onClick={callback || onClose}>
                OK
              </button>
            </div>
          </div>
        );
      },
    });
  },

  Confirm: (props) => {
    confirmAlert({
      overlayClassName: "confirm",
      customUI: ({ onClose }) => {
        return (
          <div className='customAlert'>
            <h1>{props.title}</h1>
            <p>{props.text}</p>
            <div className='buttons'>
              <button className='primary' onClick={props.onYes || onClose}>
                Yes
              </button>
              <button className='secondary' onClick={props.onNo || onClose}>
                No
              </button>
            </div>
          </div>
        );
      },
    });
  },

  ValidateUser: async (username, password, token) => {
    let data = { email: username, password, token };
    let response = await Utils.post(`${process.env.REACT_APP_URL}/portal/validate_user`, {
      data: base64_encode(JSON.stringify(data)),
    });

    let status = {
      error: false,
      token: "",
    };

    if (response.status === 200) {
      status.token = response.data.token;
      localStorage.setItem("logedInUser", JSON.stringify({ email: username, token: response.data.token }));
    } else {
      status.error = response.status;
    }
    return response, status;
  },

  RefreshToken: async () => {
    let response = await Utils.post(`${process.env.REACT_APP_URL}/portal/refresh_token`);

    if (response.status !== 200) {
      localStorage.removeItem("logedInUser");
      return window.location.reload();
    }

    return response;
  },

  FirstLogin: async (email) => {
    let errorMesssages = {
      not_found:
        "Email not found, please make sure you typed the right email, if the problem persists, please contact us",
      not_first_login: "If this email already has a valid password, please try the 'Forgot Password' session",
    };

    let response = await Utils.post(`${process.env.REACT_APP_URL}/portal/first_login`, { email: email });
    if (response.status === 401) {
      Utils.Alert({
        title: "Error",
        text: errorMesssages[response.data.error],
      });
      response.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

      return false;
    }
    if (response.status === 200) {
      return response.data;
    }
  },

  getAccountList: async () => {
    const email = await JSON.parse(localStorage.getItem("logedInUser"));

    let { data } = await Utils.get(`${process.env.REACT_APP_URL}/portal/clientes`);

    if (!data.length) return [{ nameConta: "", erpConta: "" }];

    let userData = localStorage.getItem("logedInUser");
    localStorage.setItem(
      "logedInUser",
      JSON.stringify({ ...JSON.parse(userData), name: data[0].ContatoNome }),
    );
    const filterData = data.map((conta) => {
      let nameConta = "";
      let erpConta = "";

      if (conta.ContaNomeLogistico) {
        nameConta = conta.ContaNomeLogistico;
        erpConta = conta.ContaERPLogistico;
      } else {
        nameConta = conta.ContaNomeBuyer;
        erpConta = conta.ContaERPBuyer;
      }

      let Mensagem = conta.Mensagem;
      let regionalContato = conta.RegionalContato;
      let areaContato = conta.AreaContato;

      const terceiroComprador = conta.ContaERPBuyer

      return { nameConta, erpConta, Mensagem, regionalContato, areaContato, terceiroComprador };
    });

    filterData.sort((a, b) => {
      const contaA = a.nameConta.toUpperCase();
      const contaB = b.nameConta.toUpperCase();

      if (contaA < contaB) {
        return -1;
      }
      if (contaA > contaB) {
        return 1;
      }
      return 0;
    });

    let jsonObject = filterData.map(JSON.stringify);
    let uniqueSet = new Set(jsonObject);
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);

    return uniqueArray;
  },

  ForgotPassword: async (email) => {
    try {
      let errorMesssages = {
        not_found:
          "Email not found, please make sure you typed the right email, if the problem persists, please contact us",
        not_first_login:
          "This email already has a valid password. If you don't rememberr the password, please try the 'Forgot Password' session",
      };

      let response = await Utils.post(`${process.env.REACT_APP_URL}/portal/forgot_password`, {
        email: email,
      });      
      if (response.status === 401) {
        Utils.Alert({
          title: "Error",
          text: errorMesssages[response.data.error],
        });
        return false;
      }

      return response;
    } catch (e) {
      console.log(e);
    }
  },

  GenerateHash: async (pass) => {
    const passEncoded = base64_encode(pass);
    const response = await Utils.post(`${process.env.REACT_APP_URL}/portal/generate_hash`, {
      data: passEncoded,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      Utils.Alert({
        title: `Error: ${response.status}`,
        text: `We were not able to hash your password, please try again later.`,
      });
      return;
    }
  },

  UpdateHash: async ({ new_password, old_password }) => {
    const postData = {
      new_password,
      old_password,
    };

    const result = await Utils.post(`${process.env.REACT_APP_URL}/portal/update_hash`, postData);

    return result;
  },

  getCache: (key) => {
    const { email } = JSON.parse(localStorage.getItem("logedInUser"));
    const cache = JSON.parse(localStorage.getItem(`cache_${email}`));

    if (cache && cache[key]) {
      return cache[key];
    }

    // Caso o cache não exista, retorna o valor padrão
    const defaultCache = { columns: [], columnFilter: [], orderBy: {} };
    localStorage.setItem(`cache_${email}`, JSON.stringify({ [key]: defaultCache }));
    return defaultCache;
  },

  setCache: (key, value) => {
    const { email } = JSON.parse(localStorage.getItem("logedInUser"));
    const cache = JSON.parse(localStorage.getItem(`cache_${email}`)) || {};

    cache[key] = value;
    // Salva o cache atualizado no localStorage
    localStorage.setItem(`cache_${email}`, JSON.stringify(cache));
  },

  getUserData: async () => {
    const { email, name } = await JSON.parse(localStorage.getItem("logedInUser"));
    return { email, name };
    // let { data } = await Utils.get(`${process.env.REACT_APP_DB_URL}/portal/cache/${email}`);

    if (data.length > 0) {
      let cache = JSON.parse(data[0].user);
      return cache;
    }
  },

  getShippingData: async (accounts, user) => {
    let array = [];
    let hasMoreFlag = true;
    let offSetFlag = 0;

    const groups = accounts
    .map(acc => ({
      ErpAccount: acc?.erpConta ? Number(acc.erpConta) : null,
      Regional: acc?.regionalContato ?? null,
      Area: acc?.areaContato ?? null,
      ThirdBuyer: acc?.terceiroComprador ? Number(acc.terceiroComprador) : null,
    }))
    .filter(g => Number.isFinite(g.ErpAccount))
    .filter((g => {
      const seen = new Set();
      return x => {
        const key = JSON.stringify(x);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      };
    })());

    while (hasMoreFlag) {
      const body = { groups, offset: offSetFlag };

      const { data } = await Utils.post(
        `${process.env.REACT_APP_URL}/portal/shipping`,
        body
      );

      if (data.hasMore === true) {
        offSetFlag = offSetFlag + 500;
      }

      if (data.Shipping?.length > 0) {
        data.Shipping.sort((a, b) => {
          const dataA = new Date(a.dLancamento);
          const dataB = new Date(b.dLancamento);

          if (dataA < dataB) {
            return 1;
          }
          if (dataA > dataB) {
            return -1;
          }

          const numeroA = parseInt(a.cPedidoCarga.split("-")[0]);
          const numeroB = parseInt(b.cPedidoCarga.split("-")[0]);

          if (numeroA < numeroB) {
            return -1;
          }
          if (numeroA > numeroB) {
            return 1;
          }

          const numeroA2 = parseInt(a.cPedidoCarga.split("-")[1]);
          const numeroB2 = parseInt(b.cPedidoCarga.split("-")[1]);

          if (numeroA2 < numeroB2) {
            return -1;
          }
          if (numeroA2 > numeroB2) {
            return 1;
          }

          return 0;
        });

        let response = data.Shipping.map((Shipping) => {
          let prepaymentStatus = "";

          if (Shipping.cExistePPA === "0") prepaymentStatus = "NA";
          else if (
            Shipping.cExistePPA === "1" &&
            (!Shipping.dLiberacaoPPA || Shipping.dLiberacaoPPA === "1900-01-01")
          )
            prepaymentStatus = "Pending";
          else prepaymentStatus = "Prepaid";

          return {
            IdShipping: Shipping.IdShipping,
            "Contract&Load": Shipping.cPedidoCarga,
            Contract: Shipping.nCdPedidoComercial,
            Status: Shipping.cStatus,
            "Emission Date": Shipping.dLancamento,
            Buyer: Shipping.nomeTerceiro,
            "Purchase Order": Shipping.cPedidoTerceiro === "X" ? "" : Shipping.cPedidoTerceiro,
            Client: Shipping.nomeTerceiroEntrega,
            Consignee: Shipping.nomeConsignatario,
            Currency: Shipping.nCdIndexador,
            "Purchase Order Load": Shipping.cCargaTerceiro === "X" ? "" : Shipping.cCargaTerceiro,
            "Agreed Date": Shipping.dDesejadaCliente,
            "Production Plant": Shipping.nCdEmpresa,
            //"Production Plant": Shipping.nomeEmpresa,
            "Estimated Loading Date (Factory)": Shipping.dPCP,
            "Factory Invoicing Date": Shipping.dFaturamento,
            Incoterm: Shipping.nModalidadeVenda,
            "Container Type": Shipping.nTpContainer,
            "Country of Destination": Shipping.nCdPaisDestinoFinal,
            "Payment Term": Shipping.cCondicaoPgto,
            "Prepayment Status": prepaymentStatus,
            "Prepayment Date": Shipping.dLiberacaoPPA,
            "Received Prepayment": Shipping.nValorTotalRecebimentoCambial,
            "Payment Received": Shipping.nValorTotalRecebimentoCambial,
            "Vehicle License Plate": Shipping.cPlacaVeiculo,
            "Booking Number": Shipping.cNrBooking,
            "Port of Loading": Shipping.nCdPortoOrigemBooking,
            "Port of Destination": Shipping.nCdPortoDestinoBooking,
            "Shipping Line": Shipping.nTerceiroAgenciaMaritima,
            Container: Shipping.cContainerBL,
            ETD: Shipping.dETDOrigem,
            "Departure date from the plant": Shipping.dSaidaEmpresa,
            "BL Date": Shipping.dBL,
            "BL Number": Shipping.cNrBL,
            "BL Consignee": Shipping.nCdTerceiroConsignatarioBL,
            "Courier Number": Shipping.cNrCourier,
            Vessel: Shipping.cVessel,
            FlagPendingBalance: Shipping.FlagPendingBalance,
            FlagOverdue: Shipping.FlagOverdue,
            FlagPending: Shipping.FlagPending,
            FlagPrepaid: Shipping.FlagPrepaid,
            "Net Value": Shipping.ValorIndexador,
            // eslint-disable-next-line no-dupe-keys
            Currency: Shipping.Currency,
            "Old Order": Shipping.nPedidoSubstituto,
            Product: Shipping.ComboProduct,
            "Agreed Week of Production": Shipping.AgreedWeekOfProduction,
          };
        });

        array = [...array, ...response];
      }

      hasMoreFlag = data.hasMore;
    }
    return array;
  },

  getShippingDataWithDocuments: async (userId) => {
    //TODO: atualizar para nova rota
    let array = [];
    let hasMoreFlag = true;
    let offSetFlag = 0;

    while (hasMoreFlag) {
      let { data } = await Utils.get(
        `${process.env.REACT_APP_DB_URL}/portal/shipping/${userId}/${offSetFlag}`,
      );

      if (data.hasMore === true) {
        offSetFlag = offSetFlag + 500;
      }

      if (data.Shipping.length > 0) {
        let response = data.Shipping.map((Shipping) => {
          let prepaymentStatus = "";

          if (Shipping.cExistePPA === "0") prepaymentStatus = "NA";
          else if (
            Shipping.cExistePPA === "1" &&
            (!Shipping.dLiberacaoPPA || Shipping.dLiberacaoPPA === "1900-01-01")
          )
            prepaymentStatus = "Pending";
          else prepaymentStatus = "Prepaid";

          return {
            IdShipping: Shipping.IdShipping,
            "Contract&Load": Shipping.cPedidoCarga,
            Contract: Shipping.nCdPedidoComercial,
            Load: Shipping.iCarga,
            Status: Shipping.cStatus,
            "Emission Date": Shipping.dLancamento,
            Buyer: Shipping.nomeTerceiro,
            "Purchase Order": Shipping.cPedidoTerceiro,
            Client: Shipping.nomeTerceiroEntrega,
            Consignee: Shipping.nomeConsignatario,
            Currency: Shipping.nCdIndexador,
            "Purchase Order Load": Shipping.cCargaTerceiro,
            "Production Plant": Shipping.nCdEmpresa,
            //"Production Plant": Shipping.des_sif,
            "Estimated Loading Date (Factory)": Shipping.dPCP,
            "Factory Invoicing Date": Shipping.dFaturamento,
            Incoterm: Shipping.nModalidadeVenda,
            "Country of Destination": Shipping.nCdPaisDestinoFinal,
            "Payment Term": Shipping.cCondicaoPgto,
            "Prepayment Status": prepaymentStatus,
            "Prepayment Date": Shipping.dLiberacaoPPA,
            "Vehicle License Plate": Shipping.cPlacaVeiculo,
            "Booking Number": Shipping.cNrBooking,
            "Port of Loading": Shipping.nCdPortoOrigemBooking,
            "Port of Destination": Shipping.nCdPortoDestinoBooking,
            "Shipping Line": Shipping.nTerceiroAgenciaMaritima,
            Container: Shipping.cContainerBL,
            ETD: Shipping.dETDOrigem,
            "Departure date from the plant": Shipping.dSaidaEmpresa,
            "BL Date": Shipping.dBL,
            "BL Number": Shipping.cNrBL,
            "Invoice Buyer": Shipping.nCdTerceiroInvoiceBL,
            "BL Consignee": Shipping.nCdTerceiroConsignatarioBL,
            "Courier Number": Shipping.cNrCourier,
            Vessel: Shipping.cVessel,
            "Settlement Date": Shipping.SettlementDate_c,
          };
        });

        array = [...array, ...response];
      }

      hasMoreFlag = !data.hasMore;
    }
    return array;
  },

  getProducts: async (shippingId) => {
    let { data } = await Utils.get(`${process.env.REACT_APP_URL}/portal/shipping-products/${shippingId}`);

    if (data.errorCode) {
      return [];
    }

    let response = data?.ShippingItens?.map((ShippingItens) => {
      return {
        Product: ShippingItens.nCdProduto,
        Description: ShippingItens.nomeProduto,
        "Number of Cartons": ShippingItens.nTotalVolume,
        "Net Weight": ShippingItens.nTotalPeso,
        "Gross Weight": ShippingItens.nPesoBruto,
        "Quantity (KGs)": ShippingItens.nQtde,
        "Unit of Measurement": ShippingItens.nCdUnidadeMedida,
        Price: ShippingItens.nPreco,
      };
    });
    return response;
  },

  getDocuments: async (shippingId) => {
    let { data } = await Utils.get(`${process.env.REACT_APP_URL}/portal/shipping-documents/${shippingId}`);

    if (data.detail) {
      return [{ FileName: "", Description: "", GUID: "", UploadDate: "" }];
    }

    let response = data.ShippingDocuments.map((Documents) => {
      return {
        Categoria: Documents.Categoria,
        FileName: Documents.FileName_c,
        Description: Documents.Description_c,
        GUID: Documents.GUID_c,
        UpdateDate_c: Documents.UpdateDate_c,
      };
    });

    return response;
  },

  getFinancial: async (PedidoCarga) => {
    let { data } = await Utils.get(`${process.env.REACT_APP_URL}/portal/shipping-financial/${PedidoCarga}`);

    return data;
  },

  paymentFinancial: async (
    ShippingId,
    fileName,
    conteudo,
    justificationVal,
    paymentVal,
    email,
    valorTotal,
    abaDePagamento,
    clientName,
  ) => {
    let data = [
      {
        financialTitle: "",
        recordName: "",
        shippingId: ShippingId,
        nomeArquivo: fileName,
        conteudo: conteudo,
        justification: justificationVal,
        paymentValue: paymentVal,
        email: email,
        total: valorTotal,
        currentPage: abaDePagamento,
        customerName: clientName,
      },
    ];

    let response = await Utils.post(`${process.env.REACT_APP_URL}/portal/shipping-payment`, data);

    return response;
  },

  getDocumentBase64: async (IdShipping) => {
    let { data } = await Utils.get(
      `${process.env.REACT_APP_URL}/portal/shipping-document-download/${IdShipping}`,
    );

    return data;
  },

  getAccountDocuments: async (accountId) => {
    let { data } = await Utils.get(
      `${process.env.REACT_APP_URL}/portal/shipping/account/documents/${accountId}`,
    );
    let documents = [];
    let response = data.ShippingDocuments.map((Documents) => {
      documents = response.map((document) => {
        return {
          IdShipping: document.IdShipping,
          FileName: document.FileName_c,
          Description: document.Description_c,
          GUID: document.GUID_c,
          UploadDate: document.UploadDate_c,
        };
      });
    });
    return documents;
  },

  recoverPassword: async ({ new_password, token }) => {
    const body = {
      new_password,
      token,
    };

    let response = await Utils.post(`${process.env.REACT_APP_URL}/portal/recover_password`, body);

    return response;
  },

  currencyCols: ["Payment Received"],

  dateCols: [
    "Estimated Loading Date (Factory)",
    "Emission Date",
    "Agreed Date",
    "Estimated Loading Date (Factory)",
    "Factory Invoicing Date",
    "ETD",
    "Departure date from the plant",
    "BL Date",
    "Prepayment Date",
    "Settlement Date",
  ],

  outputData: (val, col) => {
    if (Utils.dateCols.indexOf(col) >= 0) {
      if (val == "9999-12-31" || val == "1900-01-01" || val == "") {
        return "";
      } else {
        return <Moment format='DD-MM-YYYY'>{val}</Moment>;
      }
    }

    return val;
  },

  oic: {
    post: async (url, data = {}) => {
      let auth = `${process.env.REACT_APP_OIC_USER}:${process.env.REACT_APP_OIC_PASS}`;
      let postData = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${base64.encode(auth)}`,
        },
        body: JSON.stringify(data),
      };
      const res = await fetch(url, postData);
      const response = await res.json();
      return { status: res.status, data: response };
    },
    get: async (url, data = {}) => {
      let query = Object.keys(data)
        .map((item) => {
          return `${item}=${data[item]}`;
        })
        .join("&");
      let auth = `${process.env.REACT_APP_OIC_USER}:${process.env.REACT_APP_OIC_PASS}`;
      let header = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic ${base64.encode(auth)}`,
        },
      };
      const res = await fetch(`${url}?${query}`, header);
      const response = await res.json();
      return { status: res.status, data: response };
    },
  },

  shipping: {
    status: {
      1: "To be Produced",
      2: "Under Production",
      3: "Scheduled to be loaded",
      4: "Loaded on the Plant",
      5: "In Transit",
      6: "Container at the Port",
      7: "Shipped",
      8: "Settled",
      9: "Canceled",
    },
  },
};

export default Utils;
